var _svg;
import React from "react";
const RespondIcon = ({
  ...rest
}) => {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22",
    fill: "#E0F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 18H28V15C27.9982 13.3439 26.6561 12.0018 25 12H15C13.3439 12.0018 12.0018 13.3439 12 15V27.5C12 27.7761 12.2239 28 12.5 28C12.6326 28 12.7598 27.9473 12.8535 27.8535L15.707 25H18V26.5C18.0013 27.8802 19.1198 28.9987 20.5 29H28.293L31.1465 31.8535C31.2402 31.9473 31.3674 32 31.5 32C31.7761 32 32 31.7761 32 31.5V20.5C31.9987 19.1198 30.8802 18.0013 29.5 18ZM18 20.5V24H15.5C15.3674 24 15.2402 24.0527 15.1465 24.1465L13 26.293V15C13.0014 13.896 13.896 13.0014 15 13H25C26.104 13.0014 26.9986 13.896 27 15V18H20.5C19.1198 18.0013 18.0013 19.1198 18 20.5ZM31 30.293L28.8535 28.1465C28.7598 28.0527 28.6326 28 28.5 28H20.5C19.6719 27.9991 19.0009 27.3281 19 26.5V20.5C19.0009 19.6719 19.6719 19.0009 20.5 19H29.5C30.3281 19.0009 30.9991 19.6719 31 20.5V30.293Z",
    fill: "black",
    "fill-opacity": "0.87"
  })));
};
export default RespondIcon;